import { isoZ, z } from 'my-zod'

export const emailEvent = z.object({
  event: z.enum(['delivered', 'open', 'click', 'softBounce', 'bounce', 'suspension', 'unsubscribe', 'reject', 'error']),
  createdDate: isoZ.instant()
})

export const emailModel = z.object({
  id: z.string(),
  to: z.string(),
  from: z.string(),
  subject: z.string().nullable(),
  overview: z.string().nullable(),
  mailable: z.string().nullable(),
  provider: z.string().nullable(),
  category: z.string().nullable(),
  customerId: z.string().nullable(),
  destinationCustomerId: z.string().nullable(),
  customerOrderId: z.string().nullable(),
  subscriptionId: z.string().nullable(),
  reservationId: z.string().nullable(),
  customerWaiverId: z.string().nullable(),
  vehicleUseHistoryId: z.string().nullable(),
  createdDate: isoZ.instant(),
  events: emailEvent.array()
})
